import React from "react"

import { colors } from "@izettle/otto"
import { useLocalization } from "@izettle/tenko-react"

import {
  Container,
  Content,
  SmallText,
  Title2,
  Page,
  View,
} from "@/core/components/shared"

export const ErrorState = () => {
  const { text } = useLocalization()

  return (
    <Page>
      <View>
        <Container>
          <Content vCentered hCentered withNoHeaderSpace>
            <img
              src="https://cdn.izettle.com/customers/ice-creem-down.png"
              alt="404"
              height="200"
              width="200"
              aria-hidden
            />
            <Title2 color={colors.text.secondary}>
              {text("SIGNUP_CONNECTION_ERROR_TITLE")}
            </Title2>
            <SmallText color={colors.text.secondary} style={{ margin: 0 }}>
              {text("SIGNUP_CONNECTION_ERROR_DESC")}
            </SmallText>
          </Content>
        </Container>
      </View>
    </Page>
  )
}
